import { Component, EventEmitter, Input, OnChanges, Output, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-registration-docs-form',
  templateUrl: './registration-docs-form.component.html',
  styleUrls: ['./registration-docs-form.component.scss']
})
export class RegistrationDocsFormComponent implements OnChanges, OnInit {
  @Input() data: any;
  @Output() modifiedValueOutput = new EventEmitter<any>()
  @Output() onFileSelect = new EventEmitter<any>();
  @Output() onFileDelete = new EventEmitter<any>();
  listOfFile: any[];
  panNo: any
  panExpireDate: any
  adharcardNo: any
  adharExpireDate: any
  providendFundNo: any
  providendFundExpireDate: any
  esiNo: any
  esiExpireDate: any
  constructor(private translate: TranslateService) { }
  ngOnInit(): void {
    this.intializeform();
  }
  ngOnChanges(changes: SimpleChanges): void {

  }


  intializeform() {
    this.panNo = {
      lable: this.translate.instant("Registrationform.PancardNo"),
      dataField: 'PANNumber',
      formControlName: 'PANNumber',
      placeholder: this.translate.instant("Registrationform.EnterPancardNo"),
    };
    this.panExpireDate = {
      lable: this.translate.instant("Registrationform.Expdate"),
      dataField: 'PANValidity',
      formControlName: 'PANValidity',
      placeholder: this.translate.instant("Registrationform.SelectExpDate"),
    };
    this.adharcardNo = {
      lable: this.translate.instant("Registrationform.Aadharno"),
      dataField: 'AadharNumber',
      formControlName: 'AadharNumber',
      placeholder: this.translate.instant("Registrationform.EnterAadharNo"),
    };
    this.adharExpireDate = {
      lable: this.translate.instant("Registrationform.Expdate"),
      dataField: 'AadharCardValidity',
      formControlName: 'AadharCardValidity',
      placeholder: this.translate.instant("Registrationform.SelectExpDate"),
    };
    this.providendFundNo = {
      lable: this.translate.instant("Registrationform.Pfno"),
      dataField: 'ProvidendFundNumber',
      formControlName: 'ProvidendFundNumber',
      placeholder: this.translate.instant("Registrationform.EnterPfno"),
    };
    this.providendFundExpireDate = {
      lable: this.translate.instant("Registrationform.Expdate"),
      dataField: 'ProvidendFundValidity',
      formControlName: 'ProvidendFundValidity',
      placeholder: this.translate.instant("Registrationform.SelectExpDate"),
    };
    this.esiNo = {
      lable: this.translate.instant("Registrationform.ESIno"),
      dataField: 'ESINumber',
      formControlName: 'ESINumber',
      placeholder: this.translate.instant("Registrationform.SelectESIno"),
    };
    this.esiExpireDate = {
      lable: this.translate.instant("Registrationform.Expdate"),
      dataField: 'ESIValidity',
      formControlName: 'ESIValidity',
      placeholder: this.translate.instant("Registrationform.SelectExpDate"),
    };
  }
  getChangedValue(value, dataFeild) {
    this.modifiedValueOutput.emit({ value, dataFeild })
    console.log("getchanged", value, dataFeild);
  }

  onFileSelectFn(selectedFile, type) {
    this.onFileSelect.emit({ selectedFile, type });
  }

  onFileDeleteFn(selectedFile) {
    this.onFileDelete.emit(selectedFile);
  }
}

